/**
 * Normalize `clientBirthDate` to a `Date` instance.
 *
 * The calc engine reads `clientBirthDate` via methods like `getUTCFullYear`
 * (see `calcSurveyDerivatives`), so any client whose birth date is an ISO
 * string at runtime — typically a partner client fetched directly via React
 * Query rather than through the Redux hydration pipeline — will crash the
 * engine if not hydrated first.
 *
 * The engine reassigns `mutableClient.intakeSurvey = surveys.find(...)`
 * inside `calcSurveyDerivatives`, so hydrating only `intakeSurvey` is
 * insufficient — the survey objects inside `surveys[]` are what the engine
 * actually reads. Both are normalized here.
 */
type BirthDateBearer = { clientBirthDate?: Date | string | null };

export function hydrateClientBirthDates(client: Client): void {
  hydrateBirthDate(client.intakeSurvey as BirthDateBearer | undefined);

  if (Array.isArray(client.surveys)) {
    for (const survey of client.surveys) {
      hydrateBirthDate(survey as BirthDateBearer | undefined);
    }
  }
}

function hydrateBirthDate(target: BirthDateBearer | null | undefined): void {
  if (!target) return;

  const value = target.clientBirthDate;

  if (value != null && !(value instanceof Date)) {
    target.clientBirthDate = new Date(value as unknown as string);
  }
}
